import ManualBreadcrumb from './ManualBreadcrumb';

export default ManualBreadcrumb;
